import React from 'react';
import { Controller, Control, FieldValues } from 'react-hook-form';
import startCase from 'lodash/startCase';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectProps } from '@mui/material/Select';

interface SelectOption {
  name?: string;
  value?: string | number;
}

interface GlobalFormSelectProps extends Omit<SelectProps, 'name'> {
  id: string;
  name: string;
  control: Control<FieldValues>;
  options: (SelectOption | string)[];
  label?: string;
}

export const GlobalFormSelect: React.FC<GlobalFormSelectProps> = (props) => {
  const { name, control, id, label, options, ...passthroughProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { onChange, value },
        fieldState: { error },
      }) => (
        <FormControl sx={{ m: 1, minWidth: 80 }}>
          <InputLabel id={id}>{startCase(label || name)}</InputLabel>
          <Select
            labelId={'select-label'}
            id={id}
            value={value}
            label={label || name}
            onChange={onChange}
            error={!!error}
            {...passthroughProps}
          >
            {options.map((option, index) => {
              if (typeof option === 'string') {
                return (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                );
              }
              const { name: optionName, value: optionValue } = option as SelectOption;
              return (
                <MenuItem key={index} value={optionValue ?? ''}>
                  {optionName || optionValue}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      )}
    />
  );
};

// Accessibility: label or aria-label is required for all form selects for screen reader support. 